import { gql } from 'graphql-tag'

export const chainSettingFragment = gql`
  fragment ChainSettingFragment on ChainSettings {
    id
    name
    value
  }
`

export const fetchChainSettings = gql`
  query FetchChainSettings {
    chainSettings {
      ...ChainSettingFragment
    }
  }
  ${chainSettingFragment}
`

export const updateChainSettings = gql`
  mutation UpdateChainSettings($id: ID!, $value: String!) {
    updateChainSettings(id: $id, value: $value) {
      ...ChainSettingFragment
    }
  }
  ${chainSettingFragment}
`
